import { createAction } from 'lib/store-utils';

export const BOX_GLOBAL_ALERT_OPEN = createAction<string>('Global alert / open');
export const BOX_GLOBAL_ALERT_CLOSE = createAction('Global alert / close');
